import React from "react";
import "./cssfooter.css";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";
import { BsYoutube } from "react-icons/bs";
import { FaRegCopyright } from "react-icons/fa";

import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="footer_container">
      <a href="/" className="footer_logo">
        {t("myName")}
      </a>

      <ul className="permalinks">
        <li>
          <a href="#accueil">{t("navigation.home")}</a>
        </li>
        <li>
          <a href="#about">{t("navigation.about")}</a>
        </li>
        <li>
          <a href="#experiences">{t("navigation.experience")}</a>
        </li>
        <li>
          <a href="#services">{t("navigation.services")}</a>
        </li>
        <li>
          <a href="#portfolio">{t("navigation.project")}</a>
        </li>
        <li>
          <a href="#testimonial">{t("navigation.testimonials")}</a>
        </li>
        <li>
          <a href="#contact">{t("navigation.contact")}</a>
        </li>
      </ul>

      <div className="footer_media">
        <a href="https://www.linkedin.com/in/aubinsiaha" target="blank">
          <BsLinkedin />
        </a>
        <a href="https://github.com/Aubin9" target="blank">
          <FaGithub />
        </a>
        <a href="http://www.facebook.com/maautec" target="blank">
          <FaFacebookF />
        </a>
        <a href="https://x.com/aubinsiaha" target="blank">
          <BsTwitter />
        </a>
        <a href="https://www.youtube.com/@maau_tech" target="blank">
          <BsYoutube />
        </a>
      </div>

      <div className="copyRight">
        <h3>
          <FaRegCopyright />{" "}
          {/* <a href="https://www.maautek.com/"> MAAUTECH </a> */}
          {t("months.mai")} <b></b>
          {t("years.2023")} - {new Date().getFullYear()}
        </h3>
        {/* <h4>
          {t("last_update")}: {t("months.nov")} {t("years.2024")}
        </h4> */}
      </div>
    </div>
  );
};

export default Footer;
